module.exports = "/images/Location.svg";